import { CartItem } from '@vfs-digital-channels/ns-utils';
import { ProductList } from 'src/features/order/services/order-tealium-services';
import { getProductName } from 'src/features/dpo/helpers/tealium-service-helpers';

export const getProductListItemsFromCart = (cart: CartItem[]) => {
  const filteredProducts: CartItem[] = cart.filter((cartItem) => !cartItem.isTenderType);
  const products: ProductList = { name: [], quantity: [], price: [], transactionTotal: 0 };

  filteredProducts.forEach((product) => {
    const price = product.price ? product.price / 100 : 0;

    products.name.push(getProductName(product.title.toString()));
    products.quantity.push(product.quantity.toString());
    products.price.push(price.toString());
    products.transactionTotal =
      price !== 0
        ? products.transactionTotal + price * product.quantity
        : products.transactionTotal;
  });

  return {
    product_name: products.name.length ? products.name : undefined,
    product_quantity: products.quantity.length ? products.quantity : undefined,
    product_price: products.price.length ? products.price : undefined,
    transaction_total: products.transactionTotal,
  };
};
